
  $(document).ready(function($) {
  "use strict";
  
    // Função otimizada para toggle de menu
    function toggleSubMenu($link) {
      var $subMenu = $link.next('div.sub-menu-block');
      if ($subMenu.length) {
        var isHidden = $subMenu.hasClass('is-hidden');
        $link.toggleClass('selected', !isHidden);
        $subMenu.toggleClass('is-hidden', isHidden);
      }
    }
        
    // Event delegation otimizado - um único listener para todos os menus
    $(document).on('mouseenter', '.menu-item-has-children > a, .sub-menu-lists .menu-item-has-children > a', function(e) {
      e.preventDefault();
      toggleSubMenu($(this));
    }).on('mouseleave', '.menu-item-has-children > a, .sub-menu-lists .menu-item-has-children > a', function(e) {
      e.preventDefault();
      toggleSubMenu($(this));
    });

    function megaMenu() {
      var $pageFullWidth = $("#header .page-full-width");
      var parentRow, parentLeft, parentWidth;
      
      if ($pageFullWidth.length) {
        parentRow = $pageFullWidth.find('> .row');
        parentLeft = parseInt(parentRow.css("marginLeft").replace('px', '')) || 0;
      } else {
        parentRow = $("#header .page-width .row");
        parentLeft = parentRow.length ? parseInt(parentRow.offset().left) || 0 : 0;
      }
      
      if (!parentRow.length) return;
      
      parentWidth = parentRow.width();
      if (!parentWidth) return;
  
      // Processar menus do header normal
      $("#header .page-width .dt-nav li.has-mega-menu:not(.close-nav)").each(function() {
        var $thisItem = $(this);
        var $link = $thisItem.find('a');
        var $subMenu = $thisItem.find('.sub-menu-block');
        
        if ($link.length && $subMenu.length) {
          var thisItemLeft = $link.offset().left;
          var menuLeft = parseInt(thisItemLeft - parentLeft);
          $subMenu.css({
            'width': parentWidth,
            'left': -menuLeft
          });
        }
      });

      // Processar menus do sticky header
      $("sticky-header .dt-nav li.has-mega-menu:not(.close-nav)").each(function() {
        var $thisItem = $(this);
        var $link = $thisItem.find('a');
        var $subMenu = $thisItem.find('.sub-menu-block');
        
        if ($link.length && $subMenu.length) {
          var thisItemLeft = $link.offset().left;
          var menuLeft = parseInt(thisItemLeft - parentLeft) - 3;
          $subMenu.css({
            'width': parentWidth,
            'left': -menuLeft
          });
        }
      });
    }

  // Debounce para resize - evita execuções excessivas
  var resizeTimeout;
  var megaMenuResize = false;
  $(window).bind("resize", function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      if(!megaMenuResize) {
        megaMenu();
        // Estilos do nível 3 agora estão no CSS
        megaMenuResize = true;
        // Resetar flag após um tempo para permitir nova execução
        setTimeout(function() {
          megaMenuResize = false;
        }, 500);
      }
    }, 250); // Debounce de 250ms
  });
  megaMenu();

  // Estilos do nível 3 agora estão no CSS (component-mega-menu.css)
  // Não é mais necessário criar estilos inline via JavaScript
   
});


$(function() {
  if($(window).width() >=  1200) {
     $('.tabs-nav a').click(function() {
    let id = $(this).attr('href');           
    $('.tabs-nav li').removeClass('active');
    $(this).parent().addClass('active');             
    $(this).parent().parent().parent().parent().addClass('active');   
    $('.tabs-content li.dt-sc-menu-tabs').hide();      
    $(this).parent().parent().parent().parent().find(id).show();
   
    return false;
  });
}
  if($(window).width() <= 1199 ) {
  $('.mobileTabs .tabs  li').each(function(){
    $(this).click(function(){
      $(this).next('div').slideToggle(0);
    });
  })
}
});

$(document).ready(function(){
   $('#category-menu-button').on('click', function() { 
    var $button = $(this);
    var $wrapper = $('.category-wrapper');
    $button.toggleClass('open');
    $wrapper.toggleClass('open');
    $wrapper.slideToggle(0);
  });

    // Variáveis globais para rastrear o nível 3 movido
    var movedLevel3 = null;
    var originalParent = null;
    var isDesktop = false;
    var level3MoveTimeout = null;

    // Cachear verificação de desktop
    function checkDesktop() {
      isDesktop = $(window).width() >= 990;
      return isDesktop;
    }
    
    // Atualizar ao redimensionar
    $(window).on('resize', function() {
      checkDesktop();
    });
    checkDesktop();

    // Função otimizada para mover nível 3 de volta
    function moveLevel3Back($level3, $originalParent) {
      if ($level3 && $originalParent && $level3.length && $originalParent.length) {
        $level3.detach().appendTo($originalParent);
        $level3.removeAttr('style');
        $level3.removeData('original-li-selector');
      }
    }

    // Reposicionar quando há hover no item do nível 2 - OTIMIZADO
    $(document).on('mouseenter', 'ul.dt-sc-list-inline > li:not(.has-mega-menu) ul.sub-menu-lists > li', function() {
      if (!isDesktop) return;
      
      var $item = $(this);
      var $level3 = $item.find('> ul[data-level-menu="third"]');
      var $dropdownMenu = $item.closest('.dt-sc-dropdown-menu');
      
      if (!$dropdownMenu.length || !$level3.length) return;
      
      // Limpar timeout anterior
      if (level3MoveTimeout) {
        clearTimeout(level3MoveTimeout);
        level3MoveTimeout = null;
      }
      
      // Usar requestAnimationFrame para melhor performance
      requestAnimationFrame(function() {
        // Mover de volta TODOS os níveis 3 existentes
        var $existingLevel3 = $dropdownMenu.find('> ul[data-level-menu="third"]');
        $existingLevel3.each(function() {
          var $existing = $(this);
          var originalLiSelector = $existing.data('original-li-selector');
          
          if (originalLiSelector) {
            var $originalLi = $(originalLiSelector);
            if ($originalLi.length) {
              moveLevel3Back($existing, $originalLi);
            }
          }
        });
        
        // Limpar referências
        if (movedLevel3 && originalParent) {
          moveLevel3Back(movedLevel3, originalParent);
        }
        movedLevel3 = null;
        originalParent = null;
        
        // Processar nível 3 do item atual
        if ($level3.parent().is('li')) {
          var liIndex = $item.index();
          var $subMenuLists = $item.closest('ul.sub-menu-lists');
          var subMenuListsId = $subMenuLists.attr('id');
          
          if (!subMenuListsId) {
            subMenuListsId = 'sub-menu-' + Math.random().toString(36).substr(2, 9);
            $subMenuLists.attr('id', subMenuListsId);
          }
          
          var originalLiSelector = '#' + subMenuListsId + ' > li:nth-child(' + (liIndex + 1) + ')';
          
          originalParent = $item;
          movedLevel3 = $level3;
          $level3.data('original-li-selector', originalLiSelector);
          $level3.detach().appendTo($dropdownMenu);
        }
      });
    });

    // Variável para rastrear se o mouse está sobre o dropdown
    var isMouseOverDropdown = false;
    var hideLevel3Timeout = null;

    // Quando o mouse entrar no dropdown menu
    $(document).on('mouseenter', '.dt-sc-dropdown-menu', function() {
      if (isDesktop) {
        isMouseOverDropdown = true;
        // Limpar timeout de esconder
        if (hideLevel3Timeout) {
          clearTimeout(hideLevel3Timeout);
          hideLevel3Timeout = null;
        }
      }
    });

    // Quando o mouse sair do dropdown menu
    $(document).on('mouseleave', '.dt-sc-dropdown-menu', function() {
      if (!isDesktop) return;
      
      isMouseOverDropdown = false;
      
      // Limpar timeout anterior
      if (hideLevel3Timeout) {
        clearTimeout(hideLevel3Timeout);
      }
      
      hideLevel3Timeout = setTimeout(function() {
        if (!isMouseOverDropdown && movedLevel3 && originalParent) {
          moveLevel3Back(movedLevel3, originalParent);
          movedLevel3 = null;
          originalParent = null;
        }
      }, 100);
    });

    // Quando sair do hover do item do nível 2 - OTIMIZADO (removido $(':hover'))
    $(document).on('mouseleave', 'ul.dt-sc-list-inline > li:not(.has-mega-menu) ul.sub-menu-lists > li', function() {
      if (!isDesktop) return;
      
      var $item = $(this);
      
      // Limpar timeout anterior
      if (hideLevel3Timeout) {
        clearTimeout(hideLevel3Timeout);
      }
      
      hideLevel3Timeout = setTimeout(function() {
        // Só mover de volta se não estiver sobre o dropdown e tiver nível 3 movido
        if (!isMouseOverDropdown && movedLevel3 && originalParent && $item.is(originalParent)) {
          moveLevel3Back(movedLevel3, originalParent);
          movedLevel3 = null;
          originalParent = null;
        }
      }, 150);
    });

    // Esconder nível 3 quando sair - OTIMIZADO (removido $(':hover'))
    $(document).on('mouseleave', 'ul.dt-sc-list-inline > li:not(.has-mega-menu) ul.sub-menu-lists > li > ul[data-level-menu="third"]', function() {
      if (!isDesktop) return;
      
      var $level3 = $(this);
      
      // Só esconder se ainda estiver dentro do li (não foi movido)
      if ($level3.parent().is('li')) {
        // Limpar timeout anterior
        if (hideLevel3Timeout) {
          clearTimeout(hideLevel3Timeout);
        }
        
        hideLevel3Timeout = setTimeout(function() {
          // Só esconder se não estiver sobre o dropdown
          if (!isMouseOverDropdown) {
            $level3.addClass('is-hidden');
          }
        }, 100);
      }
    });
    
    // Suporte para menu mobile - otimizado
    $(document).on('toggle', 'details', function() {
      var $details = $(this);
      var isOpen = $details.attr('open') !== undefined;
      var $subMenuBlocks = $details.find('.sub-menu-block');
      
      if (isOpen) {
        $subMenuBlocks.removeClass('is-hidden');
      } else {
        $subMenuBlocks.addClass('is-hidden');
      }
    });
    
    // Suporte para subníveis no mobile - otimizado
    // Nota: Nível 3 agora é dropdown inline, não precisa de lógica especial
    $(document).on('toggle', '.menu-drawer__submenu details', function() {
      var $details = $(this);
      var isOpen = $details.attr('open') !== undefined;
      var $subMenuBlock = $details.find('.sub-menu-block');
      var $subMenu = $details.find('.menu-drawer__submenu');
      
      // Apenas para nível 2 (side panel), não para nível 3 (dropdown)
      if ($subMenu.length && !$details.hasClass('menu-drawer__dropdown')) {
        if (isOpen) {
          $subMenuBlock.removeClass('is-hidden');
          $subMenu.removeClass('is-closed').addClass('is-open');
          
          // Quando o side panel abre, fechar todos os dropdowns dentro dele
          $subMenu.find('[data-dropdown]').removeClass('is-open');
          $subMenu.find('[data-dropdown-toggle]').attr('aria-expanded', 'false');
        } else {
          $subMenuBlock.addClass('is-hidden');
          $subMenu.removeClass('is-open').addClass('is-closed');
        }
      }
    });

    // Controle do dropdown do nível 3 (substitui details/summary)
    // Handler com prioridade alta para evitar interferência com outros handlers
    $(document).on('click', '.menu-drawer__submenu [data-dropdown-toggle]', function(e) {
      // Prevenir propagação imediatamente - CRÍTICO para não fechar o side panel
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      var $toggle = $(this);
      var $dropdown = $toggle.closest('[data-dropdown]');
      var isOpen = $dropdown.hasClass('is-open');
      
      if (isOpen) {
        // Fechar dropdown
        $dropdown.removeClass('is-open');
        $toggle.attr('aria-expanded', 'false');
      } else {
        // Fechar outros dropdowns no mesmo nível antes de abrir este
        var $parentList = $dropdown.closest('li').parent();
        $parentList.find('[data-dropdown]').removeClass('is-open');
        $parentList.find('[data-dropdown-toggle]').attr('aria-expanded', 'false');
        
        // Abrir dropdown
        $dropdown.addClass('is-open');
        $toggle.attr('aria-expanded', 'true');
      }
      
      return false; // Previne comportamento padrão e propagação
    });

    // Suporte a teclado (Enter e Space)
    $(document).on('keydown', '[data-dropdown-toggle]', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        $(this).trigger('click');
      }
    });

    // Controle do dropdown alfabético de marcas (substitui details/summary)
    // Handler com prioridade alta para evitar interferência com outros handlers
    $(document).on('click', '.menu-drawer__submenu [data-brand-dropdown-toggle], [data-brand-dropdown-toggle]', function(e) {
      // Prevenir propagação imediatamente - CRÍTICO para não fechar o side panel
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      var $toggle = $(this);
      var $dropdown = $toggle.closest('[data-brand-dropdown]');
      var isOpen = $dropdown.hasClass('is-open');
      
      if (isOpen) {
        // Fechar dropdown
        $dropdown.removeClass('is-open');
        $toggle.attr('aria-expanded', 'false');
      } else {
        // Fechar outros dropdowns de marcas no mesmo nível antes de abrir este
        var $parentList = $dropdown.closest('li').parent();
        $parentList.find('[data-brand-dropdown]').removeClass('is-open');
        $parentList.find('[data-brand-dropdown-toggle]').attr('aria-expanded', 'false');
        
        // Abrir dropdown
        $dropdown.addClass('is-open');
        $toggle.attr('aria-expanded', 'true');
      }
      
      return false; // Previne comportamento padrão e propagação
    });

    // Suporte a teclado para dropdown alfabético (Enter e Space)
    $(document).on('keydown', '[data-brand-dropdown-toggle]', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        $(this).trigger('click');
      }
    });

});
